export enum FaultType {
    j1708 = 'J1708',
    j1939 = 'J1939',
    odbii = 'ODBII',
    sensor = 'Sensor',
    schedule = 'Schedule',
    go = 'Go'
}
